import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  &.ui.modal {
    width: 450px;
  }
`;

export const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

export const Title = styled(TextLayoutComponent.Header)`
  font-size: 16px;
  text-align: center;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

export const YesButton = styled(ButtonLayoutComponent.Inverted)`
  height: 40px;
  width: 125px;
`;
export const NoButton = styled(ButtonLayoutComponent)`
  height: 40px;
  width: 125px;
`;
